<template lang="pug">

    tbody

        tr
            //- Label
            td: strong {{ label }}

            //- Wert
            td  {{ viewValue }}

            //- Actions
            td.right.aligned

                //- Edit-Icon
                a(v-if="$route.name !== 'quality-rating'" v-on:click='showModal()'): i.edit.icon

                // Formular-Modal
                form: modal(ref="modal" v-on:opened="focus()")

                    //- Header
                    span(slot="header") Allgemeine Informationen bearbeiten

                    //- Formular
                    .ui.form(slot="content")
                        text-field(v-model='mutableValue' v-bind:label='label')

                    //- Actions
                    action-row(slot="footer" v-on:cancel="cancel()" v-on:save="submit()")


</template>

<script>
    import * as R from 'ramda'
    import Modal from '@/components/app/Modal'
    import ActionRow from '@/components/form/ActionRow'
    import TextField from '@/components/form/TextField'

    export default {
        name: 'product-general-information-text-field-row-component',

        components: { ActionRow, Modal, TextField },

        computed: {

            viewValue() {
                return R.compose(

                    // Wenn kein Wert angegeben, `n/a` zurueckgeben
                    R.when(
                        R.propSatisfies(length => length === 0, 'length'),
                        R.always('n/a')
                    ),

                    // Trimmen
                    R.trim,

                    // ggf. Default-Wert setzen
                    R.defaultTo(''),

                    // Wert einlesen
                    R.prop(this.property)

                )(this.value)
            }

        },

        created() {
            this.mutableValue = R.prop(this.property, this.value)
        },

        data() {
            return { mutableValue: '' }
        },

        methods: {

            cancel() {
                this.$refs.modal.close()
                this.mutableValue = R.prop(this.property, this.value)
            },

            focus() {
                this.$el.querySelector('input').focus()
            },

            showModal() {
                this.$refs.modal.show()
            },

            submit() {
                // Model erstellen
                const model = R.assoc(this.property, this.mutableValue, this.value)

                // Model patchen
                this.$store.dispatch('products/update', { id: model.id, model })

                    // Message anzeige
                    .then(() => this.$growl.success(`${this.label} wurde aktualisiert`))

                    // Modal closen
                    .then(this.$refs.modal.close)

                    // ggf. Fehler anzeigen
                    .catch(e => this.$growl.fatal(`Produktattribute ${this.label} konnte nicht gespeichert werden`, e))
            },

        },

        props: {

            label: {
                type: String,
                required: true
            },

            property: {
                type: String,
                required: true
            },

            value: {
                required: true
            },

        }

    }

</script>
